import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { ISLPContactDate } from "utils/interfaces/slp";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  CONTACT_DATE_UPDATE_SUCCESS_MSG,
  DATE_ONLY_FORMAT,
  DATE_VIEW_FORMAT,
} from "utils/constants/constant";
import { ContactDateNumber } from "utils/enums/slp";
import { IconButton } from "@mui/material";
import CalendarIcon from "components/CalendarIcon";
import moment from "moment";
import {
  IUpdateContactDateRequestPayload,
  IUpdateContactDateSuccessPayload,
} from "store/studentProfileDetails/types";
import {
  hideLoaderForBatchApiCall,
  showLoaderForBatchApiCall,
} from "utils/helper";
import { toast } from "react-toastify";

interface IGenericContactDateProps {
  slpId: number;
  contactDateNumber: ContactDateNumber;
  contactDate: Date | null;
  updateContactDateRequest: (payload: IUpdateContactDateRequestPayload) => void;
  updateSLPRequestsCallback: () => void;
}

const GenericContactDate: React.FC<IGenericContactDateProps> = (props) => {
  const {
    contactDateNumber,
    slpId,
    contactDate,
    updateContactDateRequest,
    updateSLPRequestsCallback,
  } = props;

  const [open, setOpen] = useState<boolean>(false);
  const iconRef = useRef(null);

  const { control, watch, handleSubmit } = useForm<ISLPContactDate>({
    defaultValues: {
      contactDate: contactDate?.toString() ?? null,
    },
  });
  const onUpdateContactDateSuccess = (
    response: IUpdateContactDateSuccessPayload
  ) => {
    hideLoaderForBatchApiCall();
    if (response.isSuccessStatusCode) {
      updateSLPRequestsCallback();
      toast.success(CONTACT_DATE_UPDATE_SUCCESS_MSG);
    }
  };

  const onSubmit = (data: ISLPContactDate) => {
    if (updateContactDateRequest && slpId && contactDateNumber) {
      showLoaderForBatchApiCall();
      const payload = {
        values: {
          slpId,
          contactDate: data.contactDate,
          contactDateNumber,
        },
        callback: onUpdateContactDateSuccess,
      };
      updateContactDateRequest(payload);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePickerWithOnlyIcon"]}>
        <Controller
          control={control}
          name="contactDate"
          render={({ field }) => (
            <>
              <DesktopDatePicker
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                value={watch("contactDate") ? dayjs(field.value) : null}
                onAccept={(date) => {
                  field.onChange(date ? date.format(DATE_ONLY_FORMAT) : null);
                  handleSubmit(onSubmit)();
                }}
                slots={{
                  textField: () => <span style={{ display: "none" }} />,
                }}
                slotProps={{
                  popper: {
                    anchorEl: iconRef.current,
                  },
                }}
              />
              <div className="custom-date-picker-icon">
                <span>
                  {contactDate
                    ? moment(contactDate).format(DATE_VIEW_FORMAT)
                    : "-"}
                </span>
                {/* custom date icon button */}
                <IconButton
                  ref={iconRef}
                  onClick={() => setOpen(!open)}
                  aria-label="Open date picker"
                >
                  <CalendarIcon />
                </IconButton>
              </div>
            </>
          )}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default GenericContactDate;
